import { addDoc, collection } from 'firebase/firestore';
import { removeKeysHavingUndefined } from '.';
import { firestore } from '..';
import { DOCTOOL_FIRESTORE_TABLES } from '../constants';

export async function sendAppointmentCommunication({
    data,
    aid,
}: {
    data: { msg_type: MESSAGE_TYPE; receipt_id?: number | null };
    aid: string;
}): Promise<unknown> {
    const communicationDocument = removeKeysHavingUndefined({
        ...data,
        flavour: 'dr-web',
    });

    await addDoc(
        collection(firestore, DOCTOOL_FIRESTORE_TABLES.APPOINTMENT, aid, 'comm'),
        communicationDocument,
    ).catch(console.error);

    return communicationDocument;
}

export async function cancelAllAppointmentReminders({ aid }: { aid: string }): Promise<unknown> {
    const communicationDocument = removeKeysHavingUndefined({
        msg_type: MESSAGE_TYPE.CANCEL_ALL_REMINDERS,
        flavour: 'dr-web',
    });

    await addDoc(
        collection(firestore, DOCTOOL_FIRESTORE_TABLES.APPOINTMENT, aid, 'comm'),
        communicationDocument,
    ).catch(console.error);

    return communicationDocument;
}

export enum MESSAGE_TYPE {
    BOOK_APPPOINTMENT = 'bkd_apt',
    CHECKIN_APPOINTMENT = 'ckn_apt',
    CANCEL_APPOINTMENT = 'cnl_apt',
    RESCHEDULE_APPOINTMENT = 'res_apt',
    SELF_ASSESSMENT = 'send_sa',
    GOOGLE_REVIEW = 'ggl_rev',
    FOLLOWUP_REMINDER = 'flw_rem',
    SEND_RECEIPT = 'send_rcpt',
    SEND_PRESCRIPTION = 'send_prscrpt',
    REQUEST_MEDICAL_RECORDS = 'req_mr',
    SCHEDULE_APT_REMIDNER = 'sch_apt_rem',
    SCHEDULE_FOLLOWUP_REMINDER = 'sch_flw_rem',
    CANCEL_ALL_REMINDERS = 'cnl-all-rems',
    END_VISIT = 'end_visit',
}
